import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import VueAnalytics from 'vue-analytics'
import VueGtag from 'vue-gtag'

import Buefy from 'buefy'
import App from './App.vue'

import './vee-validate'
import router from './router'
import store from './store'

import 'bulma-helpers/css/bulma-helpers.min.css'

Vue.config.productionTip = false

Sentry.init({
  dsn: 'https://5a9cdc0c78a84a38976c7b6000dbd379@sentry.io/4483432',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
})

Vue.use(Buefy)

Vue.use(VueAnalytics, {
  id: 'UA-83410159-1',
  router
})

Vue.use(VueGtag, {
  config: { id: "G-V340VM6EP7" }
}, router)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

let routeGuard = async (to, from, next) => {
  let elements = document.querySelectorAll('.hamburger-btn .icon-box-toggle')
  let element2 = document.getElementById('side-navigation-menu')

  if (elements && elements.length > 0) {
    elements.forEach(element => element.classList.remove('active'))
  }
  if (element2) {
    element2.classList.remove('is-active')
  }

  const authenticationRequired = to.meta && to.meta.authenticated
  if (authenticationRequired) {
    let result = await store.dispatch('isAuthenticated')
    if (!result) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else {
      window.fbq('track', 'PageView', {
        page_path: to.path
      });
      next()
    }
  } else {
    window.fbq('track', 'PageView', {
      page_path: to.path
    });
    next()
  }
}

router.beforeEach(routeGuard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
